import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {

  return (
    <div className="privacy-policy-page">
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
      </div>

      <div className="privacy-content">
        <section className="privacy-section">
          <h2>1. Information We Collect</h2>

          <p>
            We collect information necessary to provide and improve
            our services, including:
          </p>

          <ul>
            <li>
              <strong>Account Information:</strong> Your name and
              email address.
            </li>

            <li>
              <strong>Order Information:</strong> Delivery address,
              contact details, and purchase history.
            </li>

            <li>
              <strong>Usage Data:</strong> Information about how
              you interact with our app.
            </li>

            <li>
              <strong>Device Information:</strong> Device type,
              operating system, and technical information.
            </li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>2. How We Use Your Information</h2>

          <p>We use your information to:</p>

          <ul>
            <li>Manage your account and process orders.</li>
            <li>Arrange deliveries and provide customer support.</li>
            <li>Improve our app, products, and services.</li>
            <li>Send important account and order updates.</li>
            <li>Meet applicable legal requirements.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. Payment Protection</h2>

          <p>
            Payments made through our card payment service are
            processed by our authorized payment provider, Paystack.
          </p>

          <ul>
            <li>
              Your card details are processed by the payment provider
              and are not stored directly on our servers.
            </li>

            <li>
              Payment information is transmitted through secure
              payment connections.
            </li>

            <li>
              We receive payment confirmation and transaction
              details necessary to process your order.
            </li>
          </ul>

          <p className="security-note">
            Never share your card PIN, password, verification code,
            or other confidential payment details with anyone.
          </p>
        </section>

        <section className="privacy-section">
          <h2>4. Data Security</h2>

          <p>
            We use reasonable technical and organizational measures
            to protect your personal information from unauthorized
            access, alteration, disclosure, or misuse.
          </p>

          <p>
            However, no online service can guarantee complete
            security. Please protect your account credentials and
            avoid sharing sensitive information through unsecured
            channels.
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. Sharing Your Information</h2>

          <p>
            We may share relevant information with trusted service
            providers when necessary to:
          </p>

          <ul>
            <li>Process payments.</li>
            <li>Deliver orders.</li>
            <li>Provide technical and customer support.</li>
            <li>Meet legal or regulatory requirements.</li>
          </ul>

          <p>
            We do not sell your personal information.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Your Privacy Rights</h2>

          <p>
            Subject to applicable laws, you may request to:
          </p>

          <ul>
            <li>Access the personal information we hold about you.</li>
            <li>Correct inaccurate information.</li>
            <li>Request deletion of your personal information.</li>
            <li>Opt out of promotional communications.</li>
            <li>Request a copy of your information.</li>
          </ul>

          <p>
            Some information may need to be retained to fulfill
            legal, accounting, or transaction-related obligations.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Data Retention</h2>

          <p>
            We retain personal information only for as long as
            necessary to provide our services, complete transactions,
            resolve disputes, and meet legal obligations.
          </p>
        </section>

        <section className="privacy-section">
          <h2>8. Policy Updates</h2>

          <p>
            We may update this Privacy Policy from time to time.
            The updated version will be published in the app with
            a revised update date.
          </p>
        </section>

        <section className="privacy-section">
          <h2>9. Contact Us</h2>

          <p>
            For questions or requests concerning this Privacy Policy,
            contact us through:
          </p>

          <ul>
            <li>
              <strong>Email:</strong>{' '}
              hello@gimbiyastore.com
            </li>

            <li>
              <strong>Support:</strong>{' '}
              07065012438
            </li>
            <li>
              <strong>Logistics:</strong>{' '}
              08162437615
            </li>

            <li>
              <strong>Head Office:</strong>{' '}
              07010110977
            </li>
          </ul>
        </section>

        <div className="privacy-footer">
          <p>
            Last updated:{' '}
            {new Date().toLocaleDateString()}
          </p>

          <p>Version: 1.0.0</p>

          <p>
            Developed by <strong>BTO</strong> | ©{' '}
            {new Date().getFullYear()} Gimbiya Value Store
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;